const initialState = {
    // fetch all
    requestingFetchTransfers: false,
    successfulFetchTransfers: false,
    errorsFetchTransfers: false,
    transfers: null,

    // fetch by outbound manifest
    requestingFetchTransferByOutboundManifest: false,
    successfulFetchTransferByOutboundManifest: false,
    errorsFetchTransferByOutboundManifest: false,
    transferByOutboundManifest: null,

    // process inbound
    requestingProcessTransferInbound: false,
    successfulProcessTransferInbound: false,
    errorsProcessTransferInbound: false,
    processTransferInboundResult: null,

    // create
    requestingCreateTransfer: false,
    successfulCreateTransfer: false,
    errorCreateTransfer: false,
    transferResult: null,

}

export default function WMSTransferReducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_WMS_TRANSFERS_REQUESTING":
            return {
                ...state,
                requestingFetchTransfers: true,
                successfulFetchTransfers: false,
                errorsFetchTransfers: false,
            };
        case "FETCH_WMS_TRANSFERS_SUCCESS":
            return {
                ...state,
                requestingFetchTransfers: false,
                successfulFetchTransfers: true,
                errorsFetchTransfers: false,
                transfers: action.value,
            };
        case "FETCH_WMS_TRANSFERS_ERROR":
            return {
                ...state,
                requestingFetchTransfers: false,
                successfulFetchTransfers: false,
                errorsFetchTransfers: true,
            };
        case "FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_REQUESTING":
            return {
                ...state,
                requestingFetchTransferForInboundByManifest: true,
                successfulFetchTransferForInboundByManifest: false,
                errorsFetchTransferForInboundByManifest: false,
            };
        case "FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_SUCCESS":
            return {
                ...state,
                requestingFetchTransferForInboundByManifest: false,
                successfulFetchTransferForInboundByManifest: true,
                errorsFetchTransferForInboundByManifest: false,
                transferByOutboundManifest: action.value,
            };
        case "FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_ERROR":
            return {
                ...state,
                requestingFetchTransferForInboundByManifest: false,
                successfulFetchTransferForInboundByManifest: false,
                errorsFetchTransferForInboundByManifest: true,
            };
        case "RESET_TRANSFER_FOR_INBOUND_BY_MANIFEST_FORM":
            return {
                ...state,
                requestingFetchTransferForInboundByManifest: false,
                successfulFetchTransferForInboundByManifest: false,
                errorsFetchTransferForInboundByManifest: false,
                transferByOutboundManifest: null,
            };
        case "CREATE_NEW_TRANSFER_REQUESTING":
            return {
                ...state,
                requestingCreateTransfer: true,
                successfulCreateTransfer: false,
                errorCreateTransfer: false,
                transferResult: null
            };
        case "CREATE_NEW_TRANSFER_SUCCESS":
            return {
                ...state,
                requestingCreateTransfer: false,
                successfulCreateTransfer: true,
                errorCreateTransfer: false,
                transferResult: action.value
            };
        case "CREATE_NEW_TRANSFER_ERROR":
            return {
                ...state,
                requestingCreateTransfer: false,
                successfulCreateTransfer: false,
                errorCreateTransfer: true,
                transferResult: null
            };
        case "CREATE_NEW_TRANSFER_RESET":
            return {
                ...state,
                requestingCreateTransfer: false,
                successfulCreateTransfer: false,
                errorCreateTransfer: false,
                transferResult: null
            };
        case "PROCESS_TRANSFER_INBOUND_REQUESTING":
            return {
                ...state,
                requestingProcessTransferInbound: true,
                successfulProcessTransferInbound: false,
                errorsProcessTransferInbound: false,
            };
        case "PROCESS_TRANSFER_INBOUND_SUCCESS":
            return {
                ...state,
                requestingProcessTransferInbound: false,
                successfulProcessTransferInbound: true,
                errorsProcessTransferInbound: false,
                processTransferInboundResult: action.value,
            };
        case "PROCESS_TRANSFER_INBOUND_ERROR":
            return {
                ...state,
                requestingProcessTransferInbound: false,
                successfulProcessTransferInbound: false,
                errorsProcessTransferInbound: true,
                processTransferInboundResult: action.value,
            };
        case "RESET_TRANSFER_INBOUND_FORM":
            return {
                ...state,
                requestingProcessTransferInbound: false,
                successfulProcessTransferInbound: false,
                errorsProcessTransferInbound: false,
                processTransferInboundResult: null,
            };
        default:
            return state;
    }
}